"use strict";
/**
 * Adds the parent frame id information to the request header.
 *
 * @param options The request options
 * @param parentFrameId is the UUID for each page request
 *
 * @author Madhusudhana RK
 */
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const log_1 = require("@aurora/shared-utils/log");
const log = (0, log_1.getLog)(module);
const parentFrameLink = new client_1.ApolloLink((operation, forward) => {
    const context = operation.getContext();
    const { parentFrameId } = context;
    if (parentFrameId) {
        context.headers['Kh-Community-Frame-Id'] = parentFrameId;
        operation.setContext(Object.assign({}, context));
    }
    else {
        log.debug('Operation "%s" has no parent frame', operation.operationName);
    }
    return forward(operation);
});
exports.default = parentFrameLink;
//# sourceMappingURL=parentFrameLink.js.map